// extracted by mini-css-extract-plugin
export default {"spinner":"device-reset__spinner","control":"device-reset__control"};